import instance from "services";
import {User} from "../../../models/user";
import {BaseResponse} from "../../../models/base-response";

export default CreateUser

async function CreateUser(request: Partial<CreateUserRequest>): Promise<BaseResponse<User>> {
    const response = await instance.post(`/v1/backoffice/backoffice-users/`, request);
    return response.data.data;
}
export interface CreateUserRequest {
    email: string;
    firstName: string;
    lastName: string;
    password: string;
    passwordConfirmation: string;
    isActive: boolean;
}
